/**
 * Rutas que se sirven sin sesión de B2C.
 *
 * La página de impresión de diseños SVG la abre el generador de diseños —la aplicación de escritorio
 * que renderiza los lotes— con un Chrome automatizado, y ese Chrome no puede pasar por el login
 * interactivo de B2C. Un operario que entre a la misma ruta desde el admin sigue llegando
 * autenticado y con el menú de siempre: esto solo cambia lo que ocurre cuando no hay sesión.
 *
 * Añadir rutas aquí las deja accesibles a cualquiera que conozca la URL. Antes de tocar esta lista,
 * mirar qué endpoints llama la página: si alguno exige token, la página se abrirá y fallará por
 * dentro, que es peor que no abrirse.
 */
const RUTAS_SIN_AUTENTICACION = [/^\/impresionBibliotecasSvg(\/|$)/i]

export const esRutaSinAutenticacion = (pathname) =>
  RUTAS_SIN_AUTENTICACION.some((ruta) => ruta.test(pathname || ''))

export default esRutaSinAutenticacion
